import React from 'react';
import Layout from '../common/Layout';
import SEO from '../common/SEO';

const Error = () => (
    <>
        <SEO
            title="Nie znaleziono strony | BlackWave Augustów"
            description="Ta strona nie istnieje. Wróć do oferty wynajmu motorówek BlackWave w Augustowie."
            robots="noindex, follow"
            canonicalPath={null}
        />
        <Layout>
            <div className="error-area ptb--200 ptb_sm--60 ptb_md--80">
                <div className="container">
                    <div className="row align-item-center">
                        <div className="col-lg-12">
                            <div className="error-inner">
                                <h1>404</h1>
                                <h2 className="title">Nie znaleziono strony</h2>
                                <p className="description">Adres jest nieprawidłowy albo strona została przeniesiona.</p>
                                <div className="view-more-button">
                                    <a className="btn-default" href="/">Wróć do strony głównej</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    </>
);

export default Error;
